const DeviceType = {
  light: [
    'LightRgbw5',
    'LightRgbw4',
    'LightRgbw3',
    'LightRgbw2',
    'LightRgbw1',
    'LightWw3',
    'LightWw2',
    'LightWw1',
    'LedStripRgbw2',
    'LedStripRgbw1',
    'LedStripRgb',
    'LightRgb4'
  ],

  temperature: [
    'rgba(239, 158, 114, 0.8)',
    'rgba(234, 183, 156, 0.8)',
    'rgba(228, 228, 228, 0.8)',
    'rgba(159, 187, 228, 0.8)',
    'rgba(136, 175, 233, 0.8)'
  ],
  temperature2: [
    'rgba(244,169,133,1)',
    'rgba(246,211,194,1)',
    'rgba(234,234,234,1)',
    'rgba(198,238,235,1)',
    'rgba(169,217,214,1)'
  ],
  hue: [
    'hsl(0, 100%, 50%)',
    'hsl(29, 100%, 50%)',
    'hsl(60, 100%, 50%)',
    'hsl(74, 100%, 59%)',
    'hsl(116, 100%, 74%)',
    'hsl(180, 100%, 50%)',
    'hsl(223, 100%, 50%)',
    'hsl(274, 100%, 50%)',
    'hsl(313, 100%, 50%)',
    'hsl(0, 100%, 50%)'
  ],
  hueIndex: [0, 29, 60, 74, 116, 180, 223, 274, 313],
  switch: [
    'Switch1',
    'Switch2',
    'Switch3',
    'Switch4',
    'Switch5',
    'Switch6',
    'ZigbeeSwitch1',
    'ZigbeeSwitch2',
    'ZigbeeSwitch3'
  ],
  powerStrip: ['PowerStrip', 'PowerStrip2'],
  sensor: [
    'SensorMo',
    'SensorSos',
    'SensorWater',
    'AudibleAlarm',
    'SensorSmoke',
    'SensorTh',
    'SmartButton',
    'SensorTh2',
    'SensorDo',
    'SensorRadar',
    'HomeCamera',
    'HomeCameraPro',
    'HomeCameraProPlus',
    'notype',
    'Siren'
  ],
  date: ['SensorMo', 'SensorRadar'],
  temp: ['SensorTh', 'SensorTh2', 'SensorRefTh', 'SensorRefTh2'],
  openClose: ['SensorDo'],
  blind: ['Blind', 'Blind2'],
  alarm: [
    'SensorGas2',
    'SensorWater2',
    'SensorWater3',
    'SensorSmoke3',
    'SensorSmoke4'
  ],
  doorlock: ['SmartDoorLock', 'ZigbeeDoorlock']
};

export default DeviceType;
